/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { DropDownToggle } from './DropDown.styles'

const ToggleButton = ({ label, toggleMenu, opened }) => {
  return (
    <DropDownToggle primary onClick={toggleMenu}>
      {label}
      <i className="icon">
        {opened ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </i>
    </DropDownToggle>
  )
}

ToggleButton.propTypes = {
  label: PropTypes.string,
  toggleMenu: PropTypes.func,
  opened: PropTypes.bool
}

const useDropdown = ({ active = null, items, callback }) => {
  const [selected, setSelected] = useState(active)
  const [opened, setOpened] = useState(false)

  const activeItem = items.find(item => item.id === selected)
  const menuItems = items.filter(item => item.id !== selected)

  function toggleMenu() {
    setOpened(!opened)
    callback && callback(!opened)
  }

  useEffect(() => {
    setSelected(active)
  }, [active])

  useEffect(() => {
    setOpened(false)
  }, [selected])

  return {
    renderToggleButton: props => (
      <ToggleButton toggleMenu={toggleMenu} opened={opened} {...props} />
    ),
    setSelected,
    toggle: toggleMenu,
    menuItems,
    activeItem,
    opened
  }
}

export default useDropdown
